// mixins/itemsPerBreakpoint.js
const DEFAULT_PER_VIEW = 3

export default {
  data() {
    return {
      currentPerView: DEFAULT_PER_VIEW,
    }
  },
  computed: {
    breakPoints() {
      return [
        { maxWidth: 5000, minWidth: 1200, perView: 4 },
        { maxWidth: 1280, minWidth: 990, perView: 5 },
        { maxWidth: 990, minWidth: 768, perView: 4 },
        { maxWidth: 768, minWidth: 520, perView: 3 },
        { maxWidth: 520, minWidth: 0, perView: 2 },
      ]
    },
  },
  methods: {
    breakPointsHandler() {
      const windowWidth = window.innerWidth

      const matchedBreakpoint = this.breakPoints.find(
        (breakpoint) =>
          windowWidth <= breakpoint.maxWidth &&
          windowWidth > breakpoint.minWidth
      )

      this.currentPerView = matchedBreakpoint
        ? matchedBreakpoint.perView
        : DEFAULT_PER_VIEW
    },
  },
  mounted() {
    window.addEventListener('resize', this.breakPointsHandler)
    this.breakPointsHandler()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.breakPointsHandler)
  },
}
